import React from 'react';

import { ChipColor, ChipMember } from '@pkg/components';
import { useAppSelector, useBreakpoints } from '@pkg/hooks';

import { Wrapper } from './YatStatic.style';

export interface YatStaticProps {
    // Used only temporarily to occupy invisible space behind
    // the absolutely positioned `YatPickerDropdown`.
    tempHidden?: boolean;
}

export function YatStatic({ tempHidden = false }: YatStaticProps) {
    const { isMobile } = useBreakpoints();
    const eid = useAppSelector((state) => state.yatPage.eid);

    if (!eid) return null;

    // TODO: Not sure why this component was made over the existing
    // `YatTile` (and previous `YatBadge`), but this still requires
    // styling to reflect the `eid > rhythm score`.
    return (
        <Wrapper $tempHidden={tempHidden}>
            <ChipMember yat={eid || undefined} color={ChipColor.Transparent} size={isMobile ? 'medium' : 'large'} />
        </Wrapper>
    );
}
